<template>
  <div>
    <chart-card :chart-data="pieChart" chart-type="Pie" :render="render">
      <template slot="header">
        <h4 class="card-title">{{title}} <i v-if="tooltip" v-tooltip.top-center="tooltip" class="fas fa-question-circle small"/></h4>
        <p class="card-category">{{subtitle}}</p>
      </template>
      <template slot="footer">
        <div class="legend row ml-0">
          <span v-for="company in companies" :key="company.id">
            <i :class="'fas fa-circle ct-legend-'+company.color"/>
            {{company.profile.companyName}}
            &nbsp;
          </span>
        </div>
        <hr>
        <div class="stats">
          <i class="far fa-clock"></i> This Month
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import {ChartCard} from 'src/components/index'
export default {
  name: 'Leads-Pie-Chart-Multi-View-Card',
  components: {
    ChartCard
  },
  props: {
    title:      {type: String, required: false},
    tooltip:    {type: String, required: false},
    leadstatus: {type: Object, required: true}, // status to filter on 
    render:     {type: Boolean, default: false}
  },
  computed: {
    subtitle () {
      //console.log('subtitle: ', this.$store.getters.companySelected)
      if (this.$store.getters.periodSelected) {
        return this.$store.getters.periodSelected.label
      }
      return ''
    },
    companies () {
      return this.$store.getters.incentifyers.filter(c => !c.archived)
    },
    pieChart () {
      let pieChart = { labels: [], series: [] }
      let count = {}
      let total = 0
      let affiliates = this.$store.getters.affiliatesJson
      this.$store.getters.incentifyers.forEach(company => {
        this.$store.getters.leadsJson.forCompanyId(company.id, {affiliates}).values.forEach(lead => {
          if (lead.status === this.leadstatus.value) {
            count[company.id] ? count[company.id]++ : count[company.id] = 1
            total++
          }
        })
      })
      Object.keys(count).forEach(companyId => {
        pieChart.labels.push(Math.round(100*count[companyId]/total) + '%')
        pieChart.series.push(Math.round(100*count[companyId]/total))
      })
      return pieChart
    }
  }

}
</script>

<style>

</style>